import { render, staticRenderFns } from "./NewCover.vue?vue&type=template&id=69cf1d44&scoped=true"
import script from "./NewCover.vue?vue&type=script&lang=js"
export * from "./NewCover.vue?vue&type=script&lang=js"
import style0 from "./NewCover.vue?vue&type=style&index=0&id=69cf1d44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cf1d44",
  null
  
)

export default component.exports